<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
  }

  const ctx: BaseProps = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
  }

  export let size: BaseProps['size'] = ctx.size || 'md'
  export let role: BaseProps['role'] = ctx.role || 'img'
  export let ariaLabel = 'Wikidata'
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  viewBox="0 0 72 72"
>
  <path fill="#fff" d="M5 17h62v38H5z" />
  <path
    fill="#d22f27"
    d="M8 20h3.027v32H8zm4.541 0h6.054v32h-6.054zm7.567 0h6.054v32h-6.054z"
  />
  <path
    fill="#61b2e4"
    d="M36.757 20h6.054v32h-6.054zm12.108 0h6.054v32h-6.054z"
  />
  <path
    fill="#5c9e31"
    d="M27.676 20h3.027v32h-3.027zm4.54 0h3.027v32h-3.027z"
  />
  <path fill="#61b2e4" d="M44.324 20h3.027v32h-3.027z" />
  <path
    fill="#5c9e31"
    d="M56.432 20h3.027v32h-3.027zm4.541 0H64v32h-3.027z"
  />
  <path
    fill="none"
    stroke="#000"
    stroke-linejoin="round"
    stroke-width="2"
    d="M5 17h62v38H5z"
  />
</svg>
